import { axios } from '~/common/utils/request'
const commonPath = 'rest/erp/logistics/v3/'

// 运单列表
export const getWaybillList = params => axios({
  url: `${commonPath}waybill/list`,
  method: 'post',
  data: params
})

// 运单创建
export const addWaybill = params => axios({
  url: `${commonPath}waybill`,
  method: 'post',
  data: params
})

// 运单签收
export const signWaybill = params => axios({
  url: `${commonPath}picking/waybill/sign`,
  method: 'put',
  data: params
})

// 运单详情
export const getWaybill = id => axios({
  url: `${commonPath}picking/waybill/detail/${id}`,
  method: 'get'
})

// 运单编辑
export const editWaybill = params => axios({
  url: `${commonPath}picking/waybill`,
  method: 'put',
  data: params
})

// 运单-联系人
export const getWaybillContacts = id => axios({
  url: `${commonPath}waybill/contacts/${id}`,
  method: 'get'
})

// 运单-跟踪
export const getWaybillExpress = id => axios({
  url: `${commonPath}waybill/express/${id}`,
  method: 'get'
})

// 关单列表
export const getTariffList = params => axios({
  url: `${commonPath}tariff/list`,
  method: 'post',
  data: params
})

// 关单-合并送货（生成送货单号）
export const mergeTariff = params => axios({
  url: `${commonPath}tariff/delivery`,
  method: 'post',
  data: params
})

// 关单详情
export const getTariff = id => axios({
  url: `${commonPath}picking/tariff/detail/${id}`,
  method: 'get'
})

// 关单编辑
export const editTariff = params => axios({
  url: `${commonPath}picking/tariff`,
  method: 'put',
  data: params
})

// 关单项列表
export const getTariffLineList = params => axios({
  url: `${commonPath}tariff_line/list`,
  method: 'post',
  data: params
})

// 关单项-导出
export const exportTariffLine = params => axios({
  url: `${commonPath}tariff_line/export`,
  responseType: "blob",
  method: 'post',
  data: params
})

// 关单项详情
export const getTariffLineDetail = id => axios({
  url: `${commonPath}tariff_line/detail/${id}`,
  method: 'get'
})

// 关单项编辑
export const editTariffLine = params => axios({
  url: `${commonPath}tariff_line`,
  method: 'put',
  data: params
})

// 承运商列表
export const getCarrierList = params => axios({
  url: `${commonPath}carrier/list`,
  method: 'post',
  data: params
})

// 承运商创建
export const createCarrier = params => axios({
  url: `${commonPath}carrier`,
  method: 'post',
  data: params
})

// 物流联系人列表
export const getLogisticsContact = params => axios({
  url: `${commonPath}client_contact/all`,
  method: 'post',
  data: params
})

// 承运商详情
export const getCarrierDetail = id => axios({
  url: `${commonPath}carrier/detail/${id}`,
  method: 'get'
})

// 承运商编辑
export const editCarrier = params => axios({
  url: `${commonPath}carrier`,
  method: 'put',
  data: params
})

// 承运商-货运方式列表
export const getCarrierShippingMethod = params => axios({
  url: `${commonPath}carrier/shipping_method/rel/list`,
  method: 'post',
  data: params
})

// 承运商-货运方式创建
export const createCarrierShippingMethod = params => axios({
  url: `${commonPath}carrier/shipping_method/rel`,
  method: 'post',
  data: params
})

// 承运商-货运方式编辑
export const editCarrierShippingMethod = params => axios({
  url: `${commonPath}carrier/shipping_method/rel`,
  method: 'put',
  data: params
})

// 承运商-货运方式删除
export const deleteCarrierShippingMethod = id => axios({
  url: `${commonPath}carrier/shipping_method/rel/${id}`,
  method: 'delete'
})
